import { useTranslation } from "react-i18next";
import { LuAlertTriangle, LuShieldClose } from "react-icons/lu";

interface ProfileAccessErrorScreenProps {
  isUserMissing: boolean;
  isRetrying: boolean;
  onLogout: () => void;
  onRetry: () => void;
}

const ProfileAccessErrorScreen = ({
  isUserMissing,
  isRetrying,
  onLogout,
  onRetry,
}: ProfileAccessErrorScreenProps) => {
  const { t } = useTranslation();
  const Icon = isUserMissing ? LuShieldClose : LuAlertTriangle;

  return (
    <main className="min-h-screen flex items-center justify-center bg-[#f5f6f6]" aria-live="polite">
      <section className="flex max-w-md flex-col items-center gap-6 rounded-lg bg-white p-8 shadow-lg">
        <div className="flex flex-col items-center gap-2">
          <Icon
            aria-hidden="true"
            className="h-16 w-16 text-vcolor"
          />

          <h1 className="text-2xl font-bold text-vcolor">
            {t(isUserMissing ? "profileAccess.userMissingTitle" : "profileAccess.loadErrorTitle")}
          </h1>

          <p className="text-center text-gray-600">
            {t(isUserMissing ? "profileAccess.userMissingDescription" : "profileAccess.loadErrorDescription")}
          </p>

          {isUserMissing && (
            <p className="text-center text-gray-600">{t("profileAccess.syncHint")}</p>
          )}
        </div>

        <button
          type="button"
          className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-vcolor px-8 text-sm font-medium text-white transition-colors hover:bg-vcolor-hover disabled:pointer-events-none disabled:opacity-50"
          disabled={!isUserMissing && isRetrying}
          onClick={isUserMissing ? onLogout : onRetry}
        >
          {t(
            isUserMissing
              ? "profileAccess.logout"
              : isRetrying
                ? "profileAccess.retrying"
                : "profileAccess.tryAgain",
          )}
        </button>
      </section>
    </main>
  );
};

export default ProfileAccessErrorScreen;
